module.exports = __webpack_public_path__ + "static/media/bombay.5afad101.png";